export class APServiceChargeEditorSubcategoriesParameterDto {
    managementCompanyId: number;
    communityId: number;
    glAccountNumber: string;
    clearCache: boolean;

    getQueryString(): string {
        const tokens = [];
        tokens.push(`managementCompanyId=${this.managementCompanyId}`);
        if (!!this.communityId) {
            tokens.push(`communityId=${this.communityId}`);
        }
        tokens.push(`glAccountNumber=${this.glAccountNumber}`);
        tokens.push(`clearCache=${this.clearCache}`);
        return `?${tokens.join('&')}`;
    }
}
